import { LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export function SignOutButton() {
  const { signOut } = useAuth();
  return (
    <button
      type="button"
      onClick={signOut}
      data-testid="sign-out-button"
      aria-label="Sign out"
      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold text-[#8C6A6C] transition-colors hover:bg-[#F4EFEA] hover:text-[#7A0016] sm:text-sm"
    >
      <LogOut className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Sign out</span>
    </button>
  );
}
